import React, { useCallback, useMemo, useState } from 'react'
import { AppTitlePage } from '../../components/AppTitlePage'
import { AppFilterInput } from '../../components/AppInput/AppFilterInput'
import { AppTable } from '../../components/AppTable/AppTable'
import { AddPlanMenuTypePopup } from './AddPlanMenuTypePopup'
import { IPopup } from '../CategoriesPage/CategoriesPage'
import { AppBtnColor } from '../../components/btn/AppBtn'
import { useGetPlanMenuTypeListQuery } from '../../core/api/PlanMenuTypeApi'
import { useParamsControl } from '../../utils/useParamsControl'
import {
  IPlanMenuTypeDto,
  IPlanMenuTypeRequest,
} from '../../core/api/dto/PlanMenuTypeDto'
import { useDeletePlanMenuType } from './hooks/useDeletePlanMenuType'

import { IChooseItems } from 'core/api/dto/BuffetDishDto'
import { AppDeletePopup } from 'entities/AppDeletePopup/AppDeletePopup'

const headerData = [{ title: 'Тип план-меню', colWidth: '95%', sort: 'name' }]

export const PlanMenuTypePage = () => {
  const pageParams = useParamsControl<
    IPlanMenuTypeRequest,
    keyof IPlanMenuTypeRequest
  >({
    withPagination: true,
    whiteList: ['search', 'ordering'],
  })
  const {
    data: planMenuTypeList,
    isLoading: isLoadingGet,
    isFetching: isFetchingGet,
  } = useGetPlanMenuTypeListQuery(
    { ...pageParams, is_archived: false },
    { skip: !pageParams },
  )
  const [openCreatePopup, setOpenCreatePopup] = useState<IPopup>({
    active: false,
    id: null,
  })
  const [chooseItems, setChooseItems] = useState<IChooseItems | null>(null)
  const [tableData, setTableData] = useState<IPlanMenuTypeDto[]>([])

  const {
    deletePopup,
    closeDeletePopup,
    onDeletePopupHandler,
    onDeleteHandler,
  } = useDeletePlanMenuType(chooseItems, setChooseItems)

  const openEditPopupHandler = useCallback(
    (id: number) => setOpenCreatePopup({ id, active: true }),
    [],
  )

  const closePopupHandler = useCallback(
    () => setOpenCreatePopup({ id: null, active: false }),
    [],
  )

  const tableActions = [
    {
      title: 'Удалить',
      ico: 'basket',
      onClick: onDeletePopupHandler,
    },
  ]

  const actions = useMemo(
    () => [
      {
        btnTitle: 'Создать тип план-меню',
        btnIco: 'add',
        onClick: () =>
          setOpenCreatePopup((prevState) => ({ ...prevState, active: true })),
        color: AppBtnColor.whiteOutlineViolet,
      },
    ],
    [],
  )
  if (!planMenuTypeList) {
    return null
  }

  return (
    <React.Fragment>
      {openCreatePopup.active && (
        <AddPlanMenuTypePopup
          closePopup={closePopupHandler}
          id={openCreatePopup.id}
        />
      )}
      {deletePopup && (
        <AppDeletePopup onClose={closeDeletePopup} onDelete={onDeleteHandler} />
      )}

      <div className="width-for-page-wrapper">
        <AppTitlePage title="Типы план-меню" actions={actions} />
        <div className="col-7-width-from-1000">
          <div className="filter-block no-wrap mt-20">
            <AppFilterInput
              fullWidth
              searchParam={'search'}
              ico={'search'}
              label={'Поиск'}
              placeholder="Например: обед"
            />
          </div>
          <AppTable
            data={planMenuTypeList}
            headerData={headerData}
            chooseItems={chooseItems}
            chooseMode
            setChooseItems={setChooseItems}
            setTableData={setTableData}
            tableDataSelectors={[
              {
                renderItem: (item) => (
                  <div
                    className={`table-link ${
                      item.isArchived ? 'delete-item' : ''
                    }`}
                    onClick={() => openEditPopupHandler(item.id)}
                  >
                    {item.name}
                  </div>
                ),
              },
            ]}
            chooseActions={tableActions}
            isLoading={isLoadingGet || isFetchingGet}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
